<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/organizations/${orgType.id}`">
        {{ orgType.name }}
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      {{ form.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Name" />
          <text-input
            v-if="orgType.id === 1"
            v-model="form.code"
            :error="form.errors.code"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Code" />
          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Email" />
          <text-input
            v-model="form.website"
            :error="form.errors.website"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Website" />
          <text-input
            v-model="form.phone"
            :error="form.errors.phone"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Phone" />
          <text-input
            v-model="form.address"
            :error="form.errors.address"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Address" />
          <text-input
            v-model="form.city"
            :error="form.errors.city"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="City" />
          <text-input
            v-model="form.region"
            :error="form.errors.region"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Province/State" />
          <select-input
            v-model="form.country"
            :error="form.errors.country"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Country">
            <option value="ID">
              Indonesia
            </option>
            <option value="CA">
              Canada
            </option>
            <option value="US">
              United States
            </option>
          </select-input>
          <text-input
            v-model="form.postal_code"
            :error="form.errors.postal_code"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Postal code" />
          <text-input
            v-show="organization.organization_type_id == 1"
            v-model="form.concern"
            :error="form.errors.concern"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Concern" />
          <textarea-input
            v-model="form.descriptions"
            :error="form.errors.descriptions"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Descriptions" />
          <text-input
            v-show="organization.organization_type_id == 2"
            v-model="form.npwp"
            :error="form.errors.npwp"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="NPWP" />
          <select-input
            v-show="organization.organization_type_id == 2"
            v-model="form.business_type"
            :error="form.errors.business_type"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="business_type">
            <option value="PT">
              PT
            </option>
            <option value="CV">
              CV
            </option>
            <option value="UD">
              UD
            </option>
            <option value="Perorangan">
              Perorangan
            </option>
            <option value="Lainnya">
              Lainnya
            </option>
          </select-input>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            v-if="!organization.deleted_at"
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy">
            Delete {{ orgType.name }}
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit">
            Update {{ orgType.name }}
          </loading-button>
        </div>
      </form>
    </div>

    <h2 class="mt-12 text-2xl font-bold">
      Contacts
    </h2>
    <div class="flex justify-end my-5">
      <Link class="btn-indigo" :href="`/contacts/create/${organization.id}`">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Detail</span>
      </Link>
    </div>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Name
            </th>
            <th class="pb-4 pt-6 px-6">
              City
            </th>
            <th class="pb-4 pt-6 px-6" colspan="2">
              Phone
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="contact in organization.contacts"
            :key="contact.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/contacts/${contact.id}/edit`">
                {{ contact.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/contacts/${contact.id}/edit`"
                tabindex="-1">
                {{ contact.city }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/contacts/${contact.id}/edit`"
                tabindex="-1">
                {{ contact.phone }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="`/contacts/${contact.id}/edit`"
                tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="organization.contacts.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">
              No contacts found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        Icon,
    },
    layout: Layout,
    props: {
        organization: Object,
        orgType: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                name: this.organization.name,
                code: this.organization.code,
                email: this.organization.email,
                website: this.organization.website,
                phone: this.organization.phone,
                address: this.organization.address,
                city: this.organization.city,
                region: this.organization.region,
                country: this.organization.country,
                postal_code: this.organization.postal_code,
                organization_type_id: this.organization.organization_type_id,
                concern: this.organization.concern,
                descriptions: this.organization.descriptions,
                npwp: this.organization.npwp,
                business_type: this.organization.business_type,
            }),
        }
    },
    methods: {
        update () {
            this.form.put(`/organizations/${this.organization.id}`)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this organization?')) {
                this.$inertia.delete(`/organizations/${this.organization.id}/${this.orgType.id}`)
            }
        },
        restore () {
            if (confirm('Are you sure you want to restore this organization?')) {
                this.$inertia.put(`/organizations/${this.organization.id}/restore`)
            }
        },
    },
}
</script>
